<template>
  <div class="my-local-container" :class="{themeElementContainer: !edit, isThemeView: view==='theme', isSynthesisView: view==='synthesis'}">
    <info-message class="msg-info" v-if="view==='theme' && !printMode" :text="$t('views.themeView.progressProposals.msgDragDrop')"/>

    <b-button 
      v-if="!theme.edit && view==='synthesis' && !printMode"
      class="edit-btn" 
      variant="link" 
      @click="theme.edit=true"
      >
        <lead-pencil-icon title="" />{{$t('views.themeView.progressProposals.btnEdit')}}
      </b-button>

    <draggable id='proposals-list' tag="ul" :list="theme.progressProposals" class="my-list-group" handle=".handle">
      <li
        :class="{liContainer: edit}"
        class="my-list-group-item"
        v-for="(proposal, index) in theme.progressProposals"
        :key="index"
      >
      <div class="list-item-div">
        <b-row class="my-row" :class="{specificThemeDetail: view==='theme' }" v-if="view==='theme' || edit">
          <div class="list-puces list-puces-handle">
            <img v-if="!printMode" src="icons/handle.png" class="handle-size handle"/>
          </div>
          <div v-if="!printMode" class="large-input">
            <div class='myform' :class="{ darkgrayBackground: (view=='theme')}">
              <span class="index">{{index+1}}.</span>
              <b-form-input 
                class="proposal-input myinput"
                maxlength="500"
                v-model="proposal.title"
                :placeholder="$t('views.themeView.progressProposals.placeholderInputTitle')"
                v-on:keyup.enter="addProgressProposal()"
              ></b-form-input> <!-- TODO PPE - vérifier la cohérence des maxlength pour tous les inputs -->
            </div>
           
            <div class='myform prioritize-form' v-if="proposal.prioritize && view==='synthesis' && proposal.title">
              <label class="mylabel" for="actions" v-html="$t('views.themeView.progressProposals.action.label')"></label>
              <b-form-input
                :placeholder="$t('views.themeView.progressProposals.action.placeholder')" 
                class="proposal-input myinput responsive-input" 
                maxlength="200"
                v-model="proposal.actions"
              ></b-form-input> <!-- id="actions" -->
            </div>

            <div class='myform prioritize-form' v-if="proposal.prioritize && view==='synthesis' && proposal.title">
              <label class="mylabel" for="deliverable" v-html="$t('views.themeView.progressProposals.deliverables.label')"></label>
              <b-form-input
                class="deliverable-proposal-input myinput responsive-input"
                maxlength="200"
                v-model="proposal.deliverable"
                :placeholder="$t('views.themeView.progressProposals.deliverables.placeholder')"
              ></b-form-input> <!-- id="deliverable" -->
              <label class="mylabel date-proposal-label" for="date" v-html="$t('views.themeView.progressProposals.date.label')"></label>
              <date-picker 
                v-model="proposal.date"
                valueType="format"
                format="DD/MM/YYYY"
                width="9em"
                :lang="datepickerLang"
                :clearable="true"
                :editable="true"
                :first-day-of-week="1"
                :placeholder="$t('views.themeView.progressProposals.date.placeholder')"                
              >
              </date-picker>          
            </div>

            <div class='myform prioritize-form' v-if="proposal.prioritize && view==='synthesis' && proposal.title">
              <label class="mylabel" for="actors" v-html="$t('views.themeView.progressProposals.actors.label')"></label>
              <b-form-input
                class="proposal-input myinput responsive-input"    
                maxlength="50"
                :placeholder="$t('views.themeView.progressProposals.actors.placeholder')"
                v-model="proposal.actors"
              ></b-form-input> <!-- id="actors" -->
            </div>
            <div v-if="view==='synthesis'" class="empty-space"></div>
          </div>
          
         <div class="right-btns" v-if="edit">
            <span class="prioritize-span">
              <input
                class="myinput"
                :id="'prioritize'+index"
                type="checkbox"
                @click="prioritize(proposal)"
                :checked="proposal.prioritize"
                :disabled="!proposal.title"
              />
              <label class="prioritize-checkbox-label" :for="'prioritize'+index" v-html="$t('views.themeView.progressProposals.checkbox')"></label> <!-- definir un id unique pour lier le label au input ou faire un form group -->
            </span>
            <inrs-delete-icon :title="$t('global.trashBtnTitle')" class="big clickable" @click="theme.progressProposals.splice(index,1)" />
          </div>
          <div v-if="!printMode && view==='theme'" class="right-btn"> <!-- :cols="size" -->
            <inrs-delete-icon :title="$t('global.trashBtnTitle')" class="big clickable" @click="theme.progressProposals.splice(index,1)" />
          </div>
        </b-row>


        <b-row class="list-text-content" v-if="(view==='synthesis' && !edit) || printMode">
          <div v-if="proposal.title" class="list-puces">{{index+1}}.</div>
          <div>
            <p class="my-p" v-if="proposal.title"><strong>{{proposal.title}}</strong></p>

            <!-- si on est sur synthèse et qu'aucune proposition de progrès n'a été enregistrée, on affiche ce message -->     
            <info-message v-if="!proposal.title && !printMode" :text="$t('views.themeView.progressProposals.msgEmpty.synthesisView')"/>
             <!-- si on est en mode impression et qu'aucune proposition de progrès n'a été enregistrée, on affiche ce message -->     
            <info-message v-if="!proposal.title && printMode" :text="$t('views.themeView.progressProposals.msgEmpty.PrintPopin')"/>

            <p
              class="my-p"
              v-if="proposal.prioritize && proposal.actions"
            >{{ $t('views.themeView.progressProposals.action.text') }} {{proposal.actions}}</p>

            <p
              class="my-p"
              v-if="proposal.prioritize && proposal.deliverable"
            >{{ $t('views.themeView.progressProposals.deliverables.text') }} {{proposal.deliverable}}</p>
            
            <p
              class="my-p"
              v-if="proposal.prioritize && proposal.actors"
            >{{ $t('views.themeView.progressProposals.actors.text') }} {{proposal.actors}}</p>

            <p 
              class="my-p"
              v-if="proposal.prioritize && proposal.date">{{ $t('views.themeView.progressProposals.date.text') }} {{proposal.date}}</p>
          </div>
        </b-row>
        </div>
      </li>
    </draggable>

    <span class="btn-container"  v-if="(view==='theme' || edit) && !printMode">
      <button
        v-if="(view==='theme' || edit) && !printMode"
        class="refonte_btn-add-icon"
        @click="addProgressProposal()"
      >
        <img src="icons/circle-plus-solid-full.svg" alt="" />{{ $t('views.themeView.progressProposals.btnAddProgressProposal') }}
      </button>

      <b-button v-if="edit" class="defaultButton floatRight" @click="updateProgressProposal()">
        <check-icon title="" />{{ $t('views.themeView.progressProposals.btnFinish') }}
      </b-button>
    </span>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import draggable from "vuedraggable";
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import LeadPencilIcon from 'vue-material-design-icons/LeadPencil.vue';
import InrsDeleteIcon from '../../icons/InrsDelete.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import InfoMessage from "../global/InfoMessage.vue";

export default {
  name: "ProgressProposals",
  components: {
    draggable,
    PlusIcon,
    LeadPencilIcon,
    InrsDeleteIcon,
    CheckIcon,
    InfoMessage,
    DatePicker 
  },
  props: {
    theme: Object,
    view: String,
    edit: Boolean,
    printMode: {
      type: Boolean,
      default: false
    }
  }, 
  beforeDestroy: function() {
    this.updateProgressProposal();
  },
  data: function() {
    return {
      //datepicker_fr: fr
      datepickerLang: {
        'days': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        'months': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        'pickers': ['7 jours suivants', '30 jours suivants', '7 jours précédents', '30 jours précédents'],
        'placeholder': {
          'date': 'Sélectionnez une date',
          'dateRange': 'Sélectionnez une période'
        }
      }
    }
  },
  methods: {
    addProgressProposal: function() {
      this.theme.progressProposals.push({title:'', prioritize:false, actions:'', deliverables:'', date:null, actors:'' })
      this.$nextTick(function () {
        $('#proposals-list > li:last-child .proposal-input').focus(); //eslint-disable-line no-undef
      })
      
    },
    prioritize: function(proposal) {
      if (proposal.prioritize) {
        proposal.prioritize = false;
      } else {
        proposal.prioritize = true;
      }
    },
    updateProgressProposal: function() {
      // on supprime les éléments vides
      var toSplice = [];
      for (let i = 0; i < this.theme.progressProposals.length; i++) {
        if (this.theme.progressProposals[i].title == "") {
          toSplice.push(i);
        }
      }
      toSplice.reverse();
      for (let j = 0; j < toSplice.length; j++) {
        this.theme.progressProposals.splice(toSplice[j], 1);
      }
      // si au final progressProposals est vide, on rajoute 1 élément vide
      if (this.theme.progressProposals.length == 0) {
        this.theme.progressProposals.push({ title: "", prioritize: false, actions: "", deliverables: "", date: null, actors: "" });
      }

      if (this.view == "synthesis") {
        this.$emit("endEdit");
      }

      // on met à jour le tableau progressProposals dans le store
      var newData = {
        type: "SET-PROGRESS_PROPOSALS",
        params: {
          themeAbbr: this.theme.abbreviation,
          progressProposals: this.theme.progressProposals
        }
      };
      this.$store.dispatch("editThemeElement", newData);
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"
@import "../../sass/_media.sass"



.my-local-container
  position: relative
  padding: 1em 0
  margin-bottom: 1em

  &.isThemeView
    .btn-container
      margin: 1em 0 0 1.7em

  &.isSynthesisView
    &.themeElementContainer
      padding-right: 6em !important

      @media print
        padding: 0 !important

  .liContainer
    background: $lightgray-3
    border-bottom: 4px solid white
    border-top: 4px solid white
    color: $darkgray-3
    padding: 0.5em 0px 1em 0px

  .btn-container
    margin: 0.5em 0 0 0
    display: flex
    justify-content: space-between

  .infoMessage
    margin: 1em 1.7em 0.5em 1.7em

  .edit-btn
    z-index: 2
    position: absolute
    top: 0
    right: 0
    color: $darkgray-2
    &:hover, &:focus
      color: $darkgray-2

  .my-list-group
    list-style-type: none
    padding: 0
    margin-bottom: 0

    .my-list-group-item
      position: relative
      margin-bottom: 1em

      &:last-child
        margin-bottom: 0

      .list-item-div
        padding-right: 1em
        padding-left: 1em

        .list-text-content
          margin-bottom: 0.5em
          flex-wrap: nowrap

          &:last-child
            margin-bottom: 0

          .my-p
            margin-bottom: 0

          .infoMessage
            @media print
              margin: 0 1.7em


        .list-puces
          text-align: center
          margin-left: 1em
          margin-right: 1em
          white-space: nowrap
          
        .list-puces-handle
          cursor: ns-resize

          .handle-size
            height: 20px
            width: 8px

        .specificThemeDetail
            padding-right: 20px
            padding-left: 15px

        .my-row
          align-items: baseline
          flex-wrap: nowrap
         
          .right-btns
            padding: 0.3em 1em 0 1em
            display: flex
            align-self: normal
            @include md 
              position: absolute
              right: 0
              bottom: 0.5em

            .prioritize-span
              margin: 0.4em 1em 0 0
              display: flex
              align-items: flex-start

              input
                position: relative
                top: 0.1em
              .prioritize-checkbox-label
                margin-left: 3px

          .right-btn
            padding-right: 1em
            padding-left: 1em
            @include md 
              margin-right: 1.5em

          .large-input
            flex-grow: 1
            padding-left: 0
            @include md 
              padding-right: 1em
              width: 100%
            @include sm 
              display: flex
              flex-direction: column

            .darkgrayBackground
              background-color: $lightgray-2
              padding-left: 1.2em
              padding-right: 1.2em
              padding-bottom: 0.6em

            .prioritize-form
              margin-left: 3em
              flex-wrap: wrap
              @include sm
                margin-left: 0

            .empty-space
              @include md
                height: 2em
                width: 100%

            .myform
              display: flex
              align-items: baseline
              @include sm 
                flex-wrap: wrap

              .index
                padding-right: 0.8em
                white-space: nowrap

              .mylabel
                width: 7em
                @include sm
                  margin-top: 1em

              .date-proposal-label
                text-align: right
                padding-right: 5px
                width: auto
                padding-left: 1em
                @include sm
                  padding-left: 0

              .proposal-input
                flex-grow: 1
                margin-top: 0.5em
                width: auto
                max-width: 100%

              .responsive-input
                @include sm
                  width: 100% !important
                  margin-top: 0em

              .deliverable-proposal-input
                flex-grow: 1
                margin-top: 0.5em
                width: 30%
                @include sm
                  margin-top: 0

</style>

